/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PdfFile/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Actions from './Actions/index'
import React from 'react'
import SentryErrorBoundary from 'DesignSystem/SentryErrorBoundary/react'
import SuspenseBoundary from 'DesignSystem/SuspenseBoundary/index'
import styles from './view.module.css'
let PdfViewer = React.lazy(() => import('DesignSystem/PdfViewer/react'))



/** @type {import('Simple/types.js').View} */
export default function PdfFile({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/PdfFile"
  
}) {
let documentPreviewUrlValueData = fromData.useDataValue({ viewPath,
context: 'document',
path: 'preview_url',
})
  return (<React.Fragment
>
<SentryErrorBoundary
  viewPath={`${viewPath}/SentryErrorBoundary`}
>
{childProps => (
<SuspenseBoundary
{...childProps}
  viewPath={`${viewPath}/SuspenseBoundary`}
>
{childProps => (
<div
  data-testid="PdfFile.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<PdfViewer
  viewPath={`${viewPath}/PdfViewer`}
 data="document.preview_url"
 url={documentPreviewUrlValueData}
/>
</div>
)}
</SuspenseBoundary>
)}
</SentryErrorBoundary>
<Actions
  viewPath={`${viewPath}/Actions`}
/>
{children}
</React.Fragment>)
}